/**
 * @file index.tsx
 *
 * @fileoverview When a search yields no results we show an empty search.
 */

import React, { useContext } from 'react';
import { Metatag } from '~/jobiqo/types/types';
import { PathContextInterface } from '~/jobiqo/models/app';
import { PathContext } from '~/jobiqo/context/app';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import RichFormattedMessage from '../../RichFormattedMessage';
import { UserContext, UserContextInterface } from '~/jobiqo/context/user';
import { isApplicant } from '~/jobiqo/lib/auth';
import JobSearchNoResultsSlot from '~/jobiqo/components/Slots/JobSearchNoResultsSlot';
import dynamic from 'next/dynamic';
import ToggleLoading from '../../JobAlert/ToggleLoading';

const JobAlertToggle = dynamic(import('~/jobiqo/components/JobAlert/Toggle'), {
  ssr: false,
  loading: () => <ToggleLoading />,
});

interface SearchEmptyProps {
  /**
   * The URL to go for resetting the current search.
   */
  resetUrl: string;

  /**
   * The Metadata from the search.
   */
  metadata: Metatag[];

  /**
   * The path context containing the current path and querystring.
   */
  querystring: string;
}

export const SearchEmpty = ({
  resetUrl,
  metadata,
  querystring,
}: SearchEmptyProps) => {
  const pathContext: PathContextInterface = useContext(PathContext);
  const userContext: UserContextInterface = useContext(UserContext);

  return (
    <JobSearchNoResultsSlot resetUrl={resetUrl}>
      {!userContext.user || isApplicant(userContext.user) ? (
        <>
          <div>
            <RichFormattedMessage
              id="empty_search"
              defaultMessage={`No results found for your search. You can still subscribe to job alerts from
        this search to receive new jobs matching this criteria in your email box:`}
            />
          </div>
          <Spacing />
          <JobAlertToggle
            selectedFacets={[]}
            metadata={metadata}
            jobCount={0}
            path={pathContext.path}
            querystring={querystring}
          />
          <Spacing size="medium" />
        </>
      ) : (
        <>
          <div>
            <RichFormattedMessage
              id="empty_search_recruiter"
              defaultMessage="No jobs were found for the selected criteria."
            />
          </div>
          <Spacing size="medium" />
        </>
      )}
    </JobSearchNoResultsSlot>
  );
};
export default SearchEmpty;
